import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-197f5818"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-visitor-title" }
const _hoisted_2 = { class: "uf-visitor-apply-btn" }
const _hoisted_3 = { class: "uf-visitor-invite-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["uf-visitor", _ctx.$route.query.shop_id == '4' ? 'bg2' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, "欢迎来访" + _toDisplayString(_ctx.$route.query.title), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.$router.push({
            name: _ctx.$RouterName.VISITOR_FORM
          })
        ))
      }, {
        default: _withCtx(() => [
          _createTextVNode("发起申请")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (
          _ctx.$router.push({
            name: _ctx.$RouterName.VISITOR_MY
          })
        ))
      }, {
        default: _withCtx(() => [
          _createTextVNode("我的邀请函")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: "uf-visitor-record",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (
        _ctx.$router.push({
          name: _ctx.$RouterName.VISITOR_RECORD
        })
      ))
    }, " 申请记录 ")
  ], 2))
}